<template>
  <DetailPageWrap :titleCardOptions="titleCardOptions" :description="describe">
    <div class="detail-demand-wrap">
      <a-row :gutter="[8, 0]" type="flex">
        <a-col :span="18">
          <div class="card-wrap">
            <div class="top-wrap">
              <div>
                <span class="title">{{ result.name }}</span>
                <span class="types-wrap">{{ result.tag }}</span>
              </div>
              <span class="icon-wrap">
                <a-icon type="eye" :style="{ color: '#364759' }" />
                <span>{{ result.browseNum }}</span>
              </span>
            </div>
            <span class="line"></span>
            <div class="describe">
              <span>{{ user.enpName }}</span>
              <span>需求类型： {{ result.demandsTypeStr }}</span>
            </div>
            <div class="describe">
              <span
                >价格:<span class="price">{{ result.priceRange === -1 ? '面议' : '￥' + result.priceRange }}</span></span
              >
              <span>{{ result.companyTypeStr }}</span>
            </div>
            <div class="describe">
              <span>发布时间：{{ result.publishTime }}</span>
            </div>
          </div>
        </a-col>
        <a-col :span="6">
          <SideWrap iconName="iconPhone.png" type="img" title="联系方式">
            <template>
              <div class="side-body-wrap">
                <div class="user-head">
                  <img src="/static/iconAvator.png" alt="" />
                </div>
                <div>联系人: {{ user.userName }}</div>
                <div>电话: {{ user.phoneNumber }}</div>
                <div>邮箱: {{ user.email }}</div>
              </div>
            </template>
          </SideWrap>
        </a-col>
      </a-row>
    </div>
  </DetailPageWrap>
</template>

<script>
import DetailPageWrap from '@/components/common/DetailPageWrap'
import SideWrap from '../../components/SideWrap.vue'
import { titleCardOptions } from './data'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { getDemandInfo } from '@/api/tradingInfos.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      titleCardOptions,
      result: {},
      user: {},
      describe: []
    }
  },
  components: {
    DetailPageWrap,
    SideWrap
  },
  created() {
    this.initDefaultValue()
  },
  mounted() {},
  methods: {
    async initDefaultValue() {
      const { id } = this.$route.query
      const { data } = await getDemandInfo(id)
      const datas = [data]
      const row = this.handlerDateFormat(datas)
      this.handlerResultMappings(row) // 处理数据的映射关系
      // console.log(row[0])
      this.result = row[0]
      this.user = row[0].user
      this.describe = [
        {
          title: '描述',
          contents: [row[0].describe]
        }
      ]
    }
  }
}
</script>
